// extracted by mini-css-extract-plugin
export default {"card":"XX-z","carouselContainer":"YX-z","carouselContent":"ZX-z"};